<template>
  <el-container class="index-con">
    <el-aside class="index-aside">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <topnav></topnav>
      </el-header>
      <el-main class="index-main">
        <tabmain></tabmain>
        <!-- 缓存的页面 -->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!-- 不缓存的页面 -->
          <router-view v-if="!$route.meta.keepAlive"></router-view>
     
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import leftnav from "../components/leftnav.vue";
import topnav from "../components/topnav.vue";
import tabmain from "../components/tabmain.vue";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    leftnav,
    topnav,
    tabmain,
  },
};
</script>

<style scoped>
.index-con {
  width: 100%;
  height: 100%;
}
.index-header {
  width: 100%;
  height: 60px !important;
  background: #ffffff;
  box-shadow: 0 3px 8px 0 rgba(177, 177, 177, 0.5);
  z-index: 2;
}
.index-aside {
  width: 225px !important;
  background: #34495e;
  overflow-x: hidden;
  overflow-y: hidden;
}
.index-main {
  background: #f1f6fd;
  overflow-x: hidden;
  /* overflow-y: hidden; */
}
.index-main::-webkit-scrollbar {
  display: none;
}
.el-header {
  padding: 0 !important;
}
.el-main {
  padding: 0 !important;
}
</style>
